import { motion } from "framer-motion";
import { Phone, CalendarCheck, MapPin } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, BOOKING_URL } from "../data/site";

export const ContactClose = () => (
  <section
    id="book"
    data-testid="contact-section"
    className="relative py-24 sm:py-32 lg:py-40 border-t border-line overflow-hidden"
  >
    <div
      aria-hidden="true"
      className="pointer-events-none absolute bottom-0 left-1/2 -translate-x-1/2 w-[900px] h-[500px] rounded-full opacity-25"
      style={{ background: "radial-gradient(ellipse, rgba(234,88,12,0.3) 0%, transparent 65%)" }}
    />
    <div className="relative max-w-4xl mx-auto px-5 sm:px-8 text-center">
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.5 }}
        className="font-mono text-[11px] uppercase tracking-[0.28em] text-orange-500 font-semibold mb-6 inline-flex items-center gap-2"
      >
        <MapPin size={13} />
        Sunshine Coast — we come to you
      </motion.p>

      <motion.h2
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.65, delay: 0.1 }}
        data-testid="contact-heading"
        className="font-display font-bold uppercase tracking-tight text-slate-50 text-5xl sm:text-7xl lg:text-8xl leading-[0.92]"
      >
        Get it sorted.
      </motion.h2>

      <motion.p
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="mt-7 text-slate-300 text-base sm:text-lg leading-relaxed max-w-xl mx-auto"
      >
        Auto electrical or air conditioning — call Sam and talk it through, or
        send a booking request and he'll get back to you to lock in a time.
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.6, delay: 0.3 }}
        className="mt-10 flex flex-col sm:flex-row justify-center gap-4"
      >
        <a
          href={PHONE_TEL}
          data-testid="contact-call-cta"
          className="inline-flex items-center justify-center gap-2.5 h-14 px-9 rounded-full bg-orange-600 hover:bg-orange-500 text-ink font-bold text-base transition-all hover:-translate-y-0.5 hover:shadow-[0_12px_40px_rgba(234,88,12,0.35)]"
        >
          <Phone size={19} strokeWidth={2.5} />
          Call Sam — {PHONE_DISPLAY}
        </a>
        <a
          href={BOOKING_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="contact-book-cta"
          className="inline-flex items-center justify-center gap-2.5 h-14 px-9 rounded-full border border-line bg-surface/60 hover:border-orange-600/60 hover:text-orange-400 text-slate-200 font-semibold text-base backdrop-blur transition-all hover:-translate-y-0.5"
        >
          <CalendarCheck size={18} />
          Book Now
        </a>
      </motion.div>
    </div>
  </section>
);
